var map = {
	"./img-1-desk.jpg": "0442",
	"./img-10-desk.jpg": "d610",
	"./img-2-desk.jpg": "4cba",
	"./img-3-desk.jpg": "c775",
	"./img-4-desk.jpg": "b7e7",
	"./img-5-desk.jpg": "02c7",
	"./img-6-desk.jpg": "1f86",
	"./img-7-desk.jpg": "e098",
	"./img-8-desk.jpg": "ce5e",
	"./img-9-desk.jpg": "3106"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7465";